import { ListCalendarViewToggle } from '@molecules/ListCalendarViewToggle';
import {
  Colors,
  GET_HEADER_HEIGHT,
  isNative,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { HomeScreenAvatar } from './HomeScreenAvatar';
import { PersonSearchWithDropdownResults } from './PersonSearchWithDropdownResults';

export function HomeScreenHeader() {
  const insets = useSafeAreaInsets();
  const styles = useDynamicStyles(createStyles, { topInset: insets.top });

  return (
    <View style={styles.navbar}>
      <View style={styles.leftSection}>
        <HomeScreenAvatar />
      </View>
      <View style={styles.centerSection}>
        <PersonSearchWithDropdownResults />
      </View>
      <View style={styles.rightSection}>
        <ListCalendarViewToggle />
      </View>
    </View>
  );
}

const createStyles = ({
  isMobile,
  topInset = 0,
}: WithResponsive<{ topInset?: number }>) => {
  const headerHeight = GET_HEADER_HEIGHT(isMobile);

  return StyleSheet.create({
    navbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: isMobile ? 12 : 16,
      paddingTop: topInset + (isMobile ? 8 : 12),
      paddingBottom: isMobile ? 8 : 12,
      paddingHorizontal: isMobile ? 12 : 16,
      width: '100%',
      height: isMobile ? headerHeight + topInset : headerHeight,
      backgroundColor: Colors.purple0,
      shadowColor: Colors.yellow0,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 1,
      shadowRadius: isNative ? 5 : 10,
      elevation: 10,
    },
    leftSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: isMobile ? 0 : 52,
    },
    centerSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      maxWidth: isMobile ? undefined : 600,
    },
    rightSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  });
};
